var map = {
	"./Itstars.png": 4180,
	"./NMRC.jpg": 8761,
	"./bortnik.png": 6705,
	"./ftz.svg": 581,
	"./ftz1.svg": 5871,
	"./ftz_en.svg": 9601,
	"./mercury.png": 1639,
	"./mgu.svg": 9624,
	"./minzdrav.png": 1755,
	"./nes-15-6.png": 4458,
	"./news-1.png": 4187,
	"./news-10-1.png": 9499,
	"./news-10-2.png": 3398,
	"./news-10-3.png": 2294,
	"./news-10-4.png": 9315,
	"./news-10.png": 5301,
	"./news-11-1.png": 7027,
	"./news-11-2.png": 1853,
	"./news-11-3.png": 9,
	"./news-11-4.png": 3405,
	"./news-11-5.png": 4426,
	"./news-11-6.png": 4859,
	"./news-11.png": 8726,
	"./news-12-1.png": 4105,
	"./news-12-2.png": 2011,
	"./news-12.png": 7043,
	"./news-13.png": 8391,
	"./news-14-1.jpg": 9229,
	"./news-14.png": 7164,
	"./news-15-1.png": 8163,
	"./news-15-2.png": 9425,
	"./news-15-3.png": 7297,
	"./news-15-4.png": 3053,
	"./news-15-5.png": 9253,
	"./news-15-6.png": 3465,
	"./news-16-1.png": 7540,
	"./news-16-2.png": 346,
	"./news-16-3.png": 7173,
	"./news-16.png": 9011,
	"./news-17-1.png": 6002,
	"./news-17.png": 7660,
	"./news-18-1.png": 34,
	"./news-18-2.png": 5776,
	"./news-18.png": 6985,
	"./news-19-1.jpg": 3293,
	"./news-19-2.png": 564,
	"./news-19.png": 968,
	"./news-2.png": 8465,
	"./news-20.jpg": 6791,
	"./news-21-1.png": 5354,
	"./news-21-2.png": 8909,
	"./news-21.png": 3045,
	"./news-22.png": 126,
	"./news-23-1.png": 5328,
	"./news-23.png": 6524,
	"./news-24-1.png": 2418,
	"./news-24.png": 9821,
	"./news-25-1.png": 2457,
	"./news-25-2.png": 7336,
	"./news-25-3.png": 4584,
	"./news-25-4.png": 637,
	"./news-25.png": 3810,
	"./news-26-1.png": 8710,
	"./news-26-2.png": 9001,
	"./news-26-3.png": 1429,
	"./news-26.png": 6407,
	"./news-27-1.png": 3014,
	"./news-27-2.png": 7101,
	"./news-27-3.png": 6196,
	"./news-27-4.png": 7566,
	"./news-27.png": 9799,
	"./news-28-1.jpg": 8506,
	"./news-28-2.png": 999,
	"./news-28-3.png": 5788,
	"./news-28.png": 4325,
	"./news-3.png": 6337,
	"./news-4.png": 3637,
	"./news-5.png": 446,
	"./news-6.png": 8704,
	"./news-7.png": 3999,
	"./news-8.png": 1954,
	"./news-9-1.png": 3175,
	"./news-9-2.png": 6861,
	"./news-9-3.png": 5611,
	"./news-9.png": 1365,
	"./news8_background.svg": 3097,
	"./news_15_background.png": 3335,
	"./nii.svg": 613,
	"./radiology.png": 4949,
	"./skolkovo.png": 8756,
	"./tel.png": 8234,
	"./test-img-1-out.png": 7078,
	"./test-img-1.png": 3235,
	"./test-img-2-out.png": 6151,
	"./test-img-2.png": 3193,
	"./test-img-3-out.png": 8993,
	"./test-img-3.png": 5678,
	"./test-img-4-out.png": 8846,
	"./test-img-4.png": 2711,
	"./test-img-5-out.png": 424,
	"./test-img-5.png": 7851,
	"./test-img-main-out.png": 3174,
	"./test-img-main.png": 9699,
	"./vk.png": 7589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6932;